import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateProduct, type UpdateProductPayload } from "@/lib/api/product.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateProduct(productId: string) {
  const token = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: UpdateProductPayload) => {
      if (!token) throw new Error("No token available")
      return updateProduct(productId, payload, token)
    },
    onSuccess: (data) => {
      // Invalidate specific product detail
      queryClient.invalidateQueries({ queryKey: ["product", productId] })
      // Invalidate the list of products for the company
      if (data.companyId) {
        queryClient.invalidateQueries({ queryKey: ["companyProducts", data.companyId] })
      }
    },
  })
}
